import {collection, EntityData} from "./entity.data";

/**
 * Defines a custom object context for a entity
 */
export class CustomObjectContextData extends EntityData<CustomObjectContextData> {
    @collection() customObjects: number[];
}
